import { useRouter } from 'next/router';
import * as React from 'react';
import { ItemsList, LinkFieldsFragment, Maybe, NavbarDropdownMenuFieldsFragment } from 'types/generated';
import NavbarLink from './NavbarLink';

type Props = {
  childData: LinkFieldsFragment | NavbarDropdownMenuFieldsFragment | ItemsList | null;
  openDropdownTitle: string | null | undefined;
  setOpenDropdownTitle: (title: string | null) => void;
  showMobileMenu: boolean;
  transparent?: boolean;
  setOpenList?: (isOpen: boolean) => void;
};

const NavbarChild = ({
  childData,
  openDropdownTitle,
  setOpenDropdownTitle,
  showMobileMenu,
  transparent,
  setOpenList,
}: Props) => {
  const [key, setKey] = React.useState<Maybe<string> | undefined>('');

  const router = useRouter();

  React.useEffect(() => {
    if (!childData) {
      return;
    }
    if (childData?.__typename === 'ItemsList') {
      setKey(childData.id);
      return;
    } else if ('title' in childData) {
      setKey(childData.title);
    }
  }, [childData, setKey]);

  if (!childData) {
    return null;
  }

  const isSelected = () => {
    if (openDropdownTitle) {
      return 'title' in childData && openDropdownTitle === childData.title;
    }
    if ('uri' in childData) {
      return childData.uri === router.asPath;
    }
    if (childData.__typename === 'NavbarDropdownMenu') {
      return !!childData?.linkCategoriesCollection?.items?.some((child) => {
        return child?.childrenCollection?.items?.some((grandChild) => {
          if (!grandChild) return false;
          if ('uri' in grandChild && grandChild.uri) {
            return grandChild.uri === router.asPath;
          }
          return false;
        });
      });
    }
    if (childData.__typename === 'ItemsList') {
      return !!childData.itemCollection?.items?.some((item) => {
        if (!item) return false;
        if ('uri' in item && item.uri) {
          return item.uri === router.asPath;
        }
        return false;
      });
    }
    return false;
  };

  return (
    <NavbarLink
      key={key}
      data={childData}
      showMobileMenu={showMobileMenu}
      isSelected={isSelected()}
      setOpenDropdownTitle={setOpenDropdownTitle}
      openDropdownTitle={openDropdownTitle}
      transparent={transparent}
      setOpenList={setOpenList}
    />
  );
};
export default NavbarChild;
